import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Routes from "./config/routes";
import { connect } from "react-redux";
import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import data from "./data/data";
// import Popup from './components/Popup';

class App extends Component {
  render() {
    // const decodedCookie = decodeURIComponent(document.cookie);
    // const doesNotWantPopup = decodedCookie.includes('itcookieset=true');
    return (
      <div className="App">
        <div className="Site-transformer">
          {/* { !doesNotWantPopup && <Popup data={ data.popup } /> } */}
          <Header data={data} />
          <div className="Site">
            <Routes />
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js